import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionMatchEventEffects } from './competition-match-event.effects'
import * as fromCompetitionMatchEvent from './competition-match-event.reducer'
import { CompetitionMatchEventSerializer } from './competition-match-event.serializer'
import { CompetitionMatchEventService } from './competition-match-event.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionMatchEvent.FEATURE_NAME,
      fromCompetitionMatchEvent.competitionMatchEventReducer
    ),
    EffectsModule.forFeature([CompetitionMatchEventEffects])
  ],
  providers: [
    CompetitionMatchEventService,
    {
      provide: CompetitionMatchEventSerializer,
      useClass: CompetitionMatchEventSerializer
    }
  ],
  declarations: []
})
export class CompetitionMatchEventModule {}
